<mat-dialog-content class="dialog-text-area">
  <div layout="row" class="btn-close">
    <button
      [mat-dialog-close]="false"
      mat-icon-button
      aria-label="Close"
      layout="row"
      layout-align="end"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <h2 class="dialog-main-text">{{ dialogInfo.primaryText }}</h2>
  <div *ngIf="dialogInfo.showInput">
    <mat-form-field appearance="outline" class="dialog-input">
      <mat-label>{{ dialogInfo.inputLabel }}</mat-label>
      <input
        matInput
        [(ngModel)]="dialogInfo.inputInitialValue"
        placeholder="{{ dialogInfo.inputLabel }}"
      />
    </mat-form-field>
  </div>
</mat-dialog-content>
<mat-dialog-actions class="dialog-btn-area" align="center">
  <button class="btn-clear" mat-raised-button [mat-dialog-close]="false">
    {{ dialogInfo.btnCancelText }}
  </button>
  <button
    class="btn-salvar"
    mat-raised-button
    [mat-dialog-close]="true"
    (click)="confirm()"
  >
    {{ dialogInfo.btnConfirmText }}
  </button>
</mat-dialog-actions>
